/* global $ */
import React from 'react'
import PropTypes from 'prop-types'

import BasePureComponent from 'utils/BasePureComponent'

import './style.scss'


export default class RetractablePanel extends BasePureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: props.open
    }

    this._bind('_toggle', '_renderToggle')
  }

  componentDidMount() {
    !this.props.open && this.toggle()
  }
  // public: force opening
  open() {
    this.setState({ open: true })
    $(this.body).show()
  }

  // public
  toggle() {
    this.setState({ open: !this.state.open })
    $(this.body).toggle('slow')
  }

  _toggle(evt) {
    evt.preventDefault()
    this.toggle()
  }

  _renderToggle() {
    const icon = this.state.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
    return this.props.isToggle ? (
      <button onClick={this._toggle} className="RetractablePanel__header__actions__toggle-btn">
      <i className="material-icons">{icon}</i>
    </button> ) : null
  }

  render() {
    return (
      <div className="RetractablePanel">
        <div className="RetractablePanel__header">
          <div className="RetractablePanel__header__name">
            <h6>{this.props.name}</h6>
          </div>
          <div className="RetractablePanel__header__actions">
            <div className="RetractablePanel__header__actions__action-btns">
              {this.props.actionButtons}
            </div>
            {this._renderToggle()}
          </div>
        </div>
        <div className="RetractablePanel__body" ref={(body) => this.body = body}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

RetractablePanel.defaultProps = {
  open: true
}

RetractablePanel.propTypes = {
  open: PropTypes.bool,
  name: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/RetractablePanel/index.js